import React, { useContext, useState } from "react";
import activityStyle from "src/Assets/css/Activity/activity.module.css";
import AvatarBadge from "src/Components/AvatarBadge";
import { ProfileHoverCard } from "src/pages/HomePage/components/ProfileHoverCard";
import feedstyles from "src/Assets/css/home/feedpost.module.css";
import dot from "src/Assets/images/dot.png";
import "./answerAndReplyNotificationModal.css";
import { Menu, MenuItem } from "@szhsin/react-menu";
import IconButton from "@material-ui/core/IconButton";
import { PiDotsThreeBold } from "react-icons/pi";
import Edit from "src/Assets/images/edit.svg";
import Location from "src/Assets/images/locationpin.png";
import like from "src/Assets/images/like.svg";
import unlike from "src/Assets/images/unlike.svg";
import { useSelector } from "react-redux";
import ReusuableDeleteDialogmodal from "src/Modules/Reusuablecomponents/ReusuableDeleteModal";
import ReusuableSendaMailModal from "src/Modules/Reusuablecomponents/ReusuableSendaMailModal";
import ReusuableReportDialogmodal from "src/Modules/Reusuablecomponents/ReusuableReportDialogmodal";
import PostMessageValidation from "src/Modules/Reusuablecomponents/PostMessageValidation";
import TextWithUrlsAndHashTags from "src/Components/TextWithUrlsAndHashTags";
import SimpleDialogDemo from "src/Modules/Reusuablecomponents/CustomizedDialogs";
import { BsDot } from "react-icons/bs";
import { Button, Typography } from "@mui/material";
import API from "../../../network";
import Tooltip from "@mui/material/Tooltip";
import {
  CommonModalContext,
  ModalType,
} from "src/context/CommonModalContext/CommonModalContext";
import MapDialog from "src/pages/HomePage/components/LocationAddress";

const AnswerAndReplyModalPost = (props) => {
  const {
    answerAndReplyMessageData,
    ansOrReplyLoading,
    tagName,
    flaggedReason,
    ansAndReplyKeword,
    onReject,
    approveAction,
    notificationId,
    senderId,
    onCloseAnswerAndReplyModal,
  } = props;
  const profileImagePath = process.env.REACT_APP_SKOPIC_IMAGE;
  const userDetails = useSelector((state) => state.SignInReducer.userDetails);

  const [editId, setEditID] = useState(null);
  const [openMap, setOpenMap] = useState(false);
  const [clickedLocation, setClickedLocation] = useState({
    locAddress: "",
    latitude: "",
    longitude: "",
  });



  const commonModalContext = useContext(CommonModalContext);

  const handleClickOpen = (address, lat, lng) => {
    setOpenMap(true);
    setClickedLocation({
      locAddress: address,
      latitude: lat,
      longitude: lng,
    });
  };

  const cancelEdit = () => {
    setEditID(null);
  };

  const updateMessage = (id, message, locationName) => {
    props.updateMessage(id, message, locationName);
    cancelEdit();
  };

  const onAskOrtagClick = (parentId) => {
    const parentMsgId = parentId;
    commonModalContext?.onOpen(ModalType.SEARCH_TAG, {
      parentMsgId,
    });
  };
  const handleCloseMap = () => {
    setOpenMap(false);
  };
  const onLikeUnlikeSelection = (id, cache) => {
    props.likeUnlike(id);
    API.fetchVoteUpStatus(id, cache);
  };
  const truncateLocationName = (locationName, newSelectedLocation) => {
    const maxLength = 40; // Set your desired max length
    const nameToDisplay = newSelectedLocation || locationName;

    if (nameToDisplay.length > maxLength) {
      return nameToDisplay.substring(0, maxLength) + "...";
    } else {
      return nameToDisplay;
    }
  };

  return (
    <>
      <div>
        {answerAndReplyMessageData?.map((result) => (
          <div className="ans-reply-post-card" key={result?.message_id}>
            <div className="profile-info">
              <div
                className={activityStyle.activityPostImageDropdownMainContainer}
              >
                <div
                  className={activityStyle.activityPostImageProfileContainer}
                >
                  <div className={activityStyle.profileimg}>
                    <div className={feedstyles.avatarContainer}>
                      <AvatarBadge
                        src={
                          result?.mainuserdata?.uimage
                            ? `${profileImagePath}${result?.mainuserdata?.uimage}`
                            : process.env.REACT_APP_DUMMY_PROFILE_IMAGE
                        }
                        alt={result?.mainuserdata?.displayName}
                        isPrimaryModerator={
                          String(result?.mainuserdata?.isPM) === "1" &&
                          String(result?.mainuserdata?.isModerator) === "1"
                        }
                        isModerator={
                          String(result?.mainuserdata?.isModerator) === "1" &&
                          String(result?.mainuserdata?.isPM) === "0"
                        }
                      />
                      <ProfileHoverCard
                        result={result}
                        filterType={props?.filterType}
                      />
                    </div>
                  </div>
                  <div
                    style={{ flex: 1 }}
                    className={activityStyle.profilename}
                  >
                    <p>{result?.mainuserdata?.displayName}</p>
                    <div className={activityStyle.timeLocationContainer}>
                      <span
                        className={
                          result?.loc_name
                            ? activityStyle.tenantAndTimeName
                            : activityStyle.tenantAndTimeNameWithoutLocation
                        }
                      >
                        {result?.Message_Time}{" "}
                        {result.edited === 1 && (
                          <span> (edited {result.updated_time})</span>
                        )}{" "}
                        in{" "}
                        <Tooltip title={result?.tenantName} arrow>
                          {result?.tenantName}
                        </Tooltip>{" "}
                      </span>
                      {(result?.loc_name || result?.newSelectedLocation) && (
                        <span className={activityStyle.locationContainer}>
                          <img
                            src={dot}
                            alt="dot"
                            className={activityStyle.dotImg}
                          />
                          <img
                            src={Location}
                            alt=""
                            className={activityStyle.locationIconImg}
                            onClick={() =>
                              handleClickOpen(
                                result?.loc_name,
                                result?.msgLat,
                                result?.msgLng,
                              )
                            }
                          />
                          <span
                            className="locationContent"
                            onClick={() =>
                              handleClickOpen(
                                result?.loc_name,
                                result?.msgLat,
                                result?.msgLng,
                              )
                            }
                          >
                            {truncateLocationName(
                              result?.loc_name,
                              result?.newSelectedLocation,
                            )}
                          </span>
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div
                  className={
                    activityStyle.activityPostCardImagePopupMainContainer
                  }
                >
                  <Menu portal={true} viewScroll="close" reposition="auto"
                    menuButton={
                      <IconButton
                        style={{
                          padding: 0,
                          width: 30,
                          height: 30,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          outline: "none",
                        }}
                        disabled={
                          (result?.communityFollowStatus === 0 &&
                            result?.TenantType === "private") ||
                          ansAndReplyKeword === "F"
                        }
                      >
                        <PiDotsThreeBold
                          fontSize={25}
                          color="rgba(0, 0, 0, 0.7)"
                          style={{
                            display:
                              ansAndReplyKeword === "F" ? "none" : "block",
                          }}
                        />
                      </IconButton>
                    }
                    transition
                    direction="bottom"
                    align="end" // keeps popup aligned with the right edge of button
                    position="anchor" // ensures menu is anchored to button
                    arrow
                    menuStyle={{
                      backgroundColor: "white",
                      borderRadius: 20,
                      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                    }}
                  >
                    {result?.mainuserdata?.userid !==
                    userDetails.userData.User_ID ? (
                      <>
                        {result?.moderatorStatus === "1" ? (
                          <>
                            <MenuItem>
                              <ReusuableDeleteDialogmodal
                                label={"Delete Post"}
                                type={props?.postType}
                                id={result?.message_id}
                                deleteMessage={() =>
                                  props?.onDelete &&
                                  props.onDelete(result?.message_id)
                                }
                                fetchContributors={() => {}}
                              />
                            </MenuItem>
                            <MenuItem>
                              <ReusuableSendaMailModal
                                displayName={result?.mainuserdata?.displayName}
                                id={result?.message_id}
                                notificationStatus={
                                  result?.mainuserdata?.notificationStatus
                                }
                              />
                            </MenuItem>
                          </>
                        ) : (
                          <>
                            <MenuItem>
                              <ReusuableReportDialogmodal
                                id={result?.message_id}
                                param={"AskorSay"}
                              />
                            </MenuItem>
                            <MenuItem>
                              <ReusuableSendaMailModal
                                displayName={result?.mainuserdata?.displayName}
                                id={result?.message_id}
                                notificationStatus={
                                  result?.mainuserdata?.notificationStatus
                                }
                              />
                            </MenuItem>
                          </>
                        )}
                      </>
                    ) : (
                      <>
                        <MenuItem
                          onClick={() => {
                            setEditID(result?.message_id);
                          }}
                        >
                          <div style={{ display: "flex", alignItems: "center", width: "100%", height: "100%", padding: "0.375rem 1.5rem", boxSizing: "border-box", cursor: "pointer" }}>
                            <img src={Edit} style={{ width: 18, height: 18, marginRight: 8, objectFit: "contain" }} alt="edit" />
                            <span style={{ fontSize: 14 }}>Edit Post</span>
                          </div>
                        </MenuItem>
                        <MenuItem>
                          <ReusuableDeleteDialogmodal
                            label={"Delete Post"}
                            type={props?.postType}
                            id={result?.message_id}
                            deleteMessage={() =>
                              props?.onDelete &&
                              props.onDelete(result?.message_id)
                            }
                            fetchContributors={() => {}}
                          />
                        </MenuItem>
                      </>
                    )}
                  </Menu>
                </div>
              </div>
            </div>
            <>
              <div className={activityStyle.activityPostDescriptionContainer}>
                {editId === result?.message_id ? (
                  <PostMessageValidation
                    id={result?.message_id}
                    Message={result?.message_text}
                    messageType={"feedTextArea"}
                    filtertype={props?.filterType}
                    post={result}
                    onCloseEdit={cancelEdit}
                    onMessagedUpdated={updateMessage}
                    latitude={result?.msgLat}
                    longitude={result?.msgLng}
                    locationAddress={result?.loc_name}
                    updateNewSelectedLocation={props?.updateNewSelectedLocation}
                    removeNewSelectedLocationKey={
                      props?.removeNewSelectedLocationKey
                    }
                  />
                ) : (
                  <Typography whiteSpace="pre-wrap" style={{ color: "#050505" }}>
                    <TextWithUrlsAndHashTags
                      Message={result?.message_text}
                      text={result?.message_text}
                      urls={result?.url}
                      hashtags={result?.tag}
                      tagActivityTenantId={
                        props?.filterType === "AnswerNotification" ||
                        props?.filterType === "ReplyNotification"
                          ? result?.tenantID
                          : undefined
                      }
                      onHashtagClick={props?.onHashTagClick}
                      style={{ color: "#050505" }}
                    />
                  </Typography>
                )}
              </div>
            </>

            {ansAndReplyKeword !== "F" ? (
              <div className="PostCounts">
                <div className={activityStyle.likeCountContainer}>
                  {result?.vote_up_count !== 0 ? (
                    <div style={{ marginTop: "-3px" }}>
                      <SimpleDialogDemo
                        voteUp={result?.vote_up_count}
                        id={result?.message_id}
                        isVoteup={"true"}
                      />
                    </div>
                  ) : (
                    <p style={{ marginBottom: "0px" }}>
                      {result?.vote_up_count === 1
                        ? `${result?.vote_up_count} Like`
                        : `${result?.vote_up_count} likes`}
                    </p>
                  )}

                  {result?.message_type === "P" ? (
                    <>
                      <BsDot className={activityStyle.dotIcon} />
                      <button
                        onClick={() =>
                          onAskOrtagClick(result?.message_parant_id)
                        }
                        className={activityStyle.likeCountContainerButton}
                        type="button"
                      >
                        {tagName}
                      </button>
                    </>
                  ) : (
                    <>
                      <BsDot className={activityStyle.dotIcon} />
                      <button
                        onClick={() =>
                          onAskOrtagClick(result?.message_parant_id)
                        }
                        className={activityStyle.likeCountContainerButton}
                        type="button"
                      >
                        ASK
                      </button>
                    </>
                  )}
                </div>
                {result?.communityFollowStatus === 0 &&
                  result?.TenantType === "private" && (
                    <p className="warning-msg-text">
                      This is a private Community, No action is permitted for
                      non member
                    </p>
                  )}
              </div>
            ) : (
              <div style={{ margin: "8px 0 4px 0", fontSize: "14px", color: "#555" }}>
                Reason: {flaggedReason}
              </div>
            )}



            {/* Actions: Ignore / Remove for Flagged Posts, or Like for standard */}
            {ansAndReplyKeword === "F" ? (
              <div className="IgnoreRemoveBtnContainer">
                <button
                  className="IgnoreRemoveBtn"
                  onClick={() => {
                    onReject(
                      result?.message_id,
                      ansAndReplyKeword,
                      result?.tenantID,
                      senderId,
                      notificationId
                    );
                    onCloseAnswerAndReplyModal();
                  }}
                >
                  Ignore
                </button>
                <button
                  className="IgnoreRemoveBtn"
                  onClick={() => {
                    approveAction(
                      result?.message_id,
                      ansAndReplyKeword,
                      result?.tenantID,
                      senderId,
                      notificationId
                    );
                    onCloseAnswerAndReplyModal();
                  }}
                >
                  Remove
                </button>
              </div>
            ) : (
              <div className="PostActions">
                <div
                  style={{
                    cursor: "pointer",
                    marginTop: "5px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Button
                    style={{
                      textTransform: "none",
                      color: "#000",
                      border: "none",
                      outline: "none !important",
                    }}
                    disabled={
                      result?.communityFollowStatus === 0 &&
                      result?.TenantType === "private"
                    }
                    variant="outlined"
                    startIcon={
                      result?.UserLikeStatus === "Active" ? (
                        <img src={like} alt="Unlike" />
                      ) : (
                        <img src={unlike} alt="Like" />
                      )
                    }
                    onClick={() =>
                      result?.UserLikeStatus === "Active"
                        ? onLikeUnlikeSelection(
                            result?.message_id,
                            "cacheUpdate"
                          )
                        : null
                    }
                  >
                    Like
                  </Button>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
      {answerAndReplyMessageData && answerAndReplyMessageData.length === 0 ? (
        ansOrReplyLoading ? (
          <div style={{ textAlign: "center", marginTop: "30px" }}>
            <p>Loading...</p>
          </div>
        ) : (
          <div style={{ textAlign: "center", marginTop: "30px" }}>
            No Data Found
          </div>
        )
      ) : null}
      <MapDialog
        open={openMap}
        onClose={handleCloseMap}
        clickedLocation={clickedLocation}
        zoomLevel={12}
      />
    </>
  );
};

export default AnswerAndReplyModalPost;
